import _typeof from "@babel/runtime/helpers/esm/typeof";

/* eslint-disable no-useless-escape  */
import Object from '../../common/object';
import request from '../../common/network';
import miloCookie from '../../common/cookie';
import miloUrl from '../../common/url';
import { isObject, g } from '../../common/base';

var getRequestUrl = function getRequestUrl(data, amsActdesc) {
  var url = "".concat(location.protocol, "//apps.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=").concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=newterminals&set_info=newterminals");

  if (amsActdesc.sServiceDepartment == 'x8' || amsActdesc.sServiceDepartment == 'newterminals' || amsActdesc.sServiceDepartment == 'group_b' || amsActdesc.sServiceDepartment == 'group_g') {
    url = "".concat(location.protocol, "//x8m8.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=").concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=newterminals&set_info=newterminals");
  } // CF，剑灵等业务特殊处理 跳转调整 add by dickma 2014.9.4


  if (amsActdesc.sServiceType == 'cf') {
    url = "".concat(location.protocol, "//cf.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=").concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=").concat(data.sData.sServiceDepartment);
  }

  if ((amsActdesc.sServiceDepartment == 'x1m1' || amsActdesc.sServiceDepartment == 'group_1') && amsActdesc.sServiceType != 'cf') {
    url = "".concat(location.protocol, "//x1m1.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=").concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=").concat(data.sData.sServiceDepartment);
  }

  if (amsActdesc.sServiceDepartment == 'x6m5' || amsActdesc.sServiceDepartment == 'group_5') {
    url = "".concat(location.protocol, "//x6m5.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=").concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=").concat(data.sData.sServiceDepartment);
  }

  if (amsActdesc.sServiceDepartment == 'x7' || amsActdesc.sServiceDepartment == 'group_6') {
    url = "".concat(location.protocol, "//x7m3.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=").concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=").concat(data.sData.sServiceDepartment);
  } // CFM红包活动，走 group_f
  // if (data.iActivityId == 40433 || amsActdesc.sServiceDepartment == 'group_f') {


  if (amsActdesc.sServiceDepartment == 'group_f') {
    url = "".concat(location.protocol, "//apps.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=").concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=group_f");
  } // add susahuang 2016/12/27
  // if (data.iActivityId == 68803 || amsActdesc.sServiceDepartment == 'djc') {


  if (amsActdesc.sServiceDepartment == 'djc') {
    url = "".concat(location.protocol, "//apps.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=").concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=").concat(data.sData.sServiceDepartment, "&set_info=").concat(data.sData.sServiceDepartment);
  } // add susahuang 2016/12/29
  // if (data.iActivityId == 100739 || data.iActivityId == 100690) {
  //   url = `${location.protocol}//act.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=${data.sData.sServiceType}&iActivityId=${data.iActivityId}&sServiceDepartment=${data.sData.sServiceDepartment}&set_info=${data.sData.sServiceDepartment}`;
  // }
  // add susahuang 2016/1/9
  // if (data.iActivityId == 101628) {
  //   url = `${location.protocol}//act.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=${data.sData.sServiceType}&iActivityId=${data.iActivityId}&sServiceDepartment=${data.sData.sServiceDepartment}&set_info=${data.sData.sServiceDepartment}`;
  // }
  // add by marsboyding 2017/4/27
  // if (data.iActivityId == 100739 || data.iActivityId == 100690 || data.iActivityId == 110170) {
  //   url = `${location.protocol}//act.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=${data.sData.sServiceType}&iActivityId=${data.iActivityId}&sServiceDepartment=${data.sData.sServiceDepartment}&set_info=${data.sData.sServiceDepartment}`;
  // }

  /* 【******************特殊处理在这里  Start*******************】*/
  // smoba
  // if (68825 == amsActdesc.iActivityId) {
  //   url = `${location.protocol}//smoba.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=${data.sData.sServiceType}&iActivityId=${data.iActivityId}&sServiceDepartment=${data.sData.sServiceDepartment}`;
  // }

  /* 【******************特殊处理在这里  End*******************】*/
  // add by marsboyding ----start

  /* 2017.5.1大活动，如果活动id号大于临界值为yxzj和cfm走特殊处理*/


  if (amsActdesc.iActivityId >= 109733) {
    if ('yxzj' == amsActdesc.sServiceType) {
      // yxzj
      // if ('yxzj' == amsActdesc.sServiceType || 110414 == data.iActivityId) { // yxzj
      url = "".concat(location.protocol, "//") + 'smoba.ams.game.qq.com/ams/ame/ame.php' + "?ameVersion=0.3&sServiceType=".concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=").concat(data.sData.sServiceDepartment);
    } else if ('cfm' == amsActdesc.sServiceType) {
      // cfm
      url = "".concat(location.protocol, "//") + 'cfm.ams.game.qq.com/ams/ame/ame.php' + "?ameVersion=0.3&sServiceType=".concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=").concat(data.sData.sServiceDepartment);
    }
  } // ----end
  // add by marsboyding ----start

  /* 如果满足一下条件：
    1.活动id号大于临界值  或者为指定白名单活动ameConfigActReg
    2.且act.desc.js中有sAmeMobileUrl
    则根据act.desc.js 决定请求服务器地址sUrl
    */
  // 设置指定白名单活动，为了让老活动也可以走配置文件


  var ameConfigActReg = /^(53977|109144|11117|106713|104271)$/;

  if ((amsActdesc.iActivityId >= 109733 || ameConfigActReg.test(amsActdesc.iActivityId)) && amsActdesc.sAmeMobileUrl && 'string' === typeof amsActdesc.sAmeMobileUrl) {
    // 先灰度新终端,group_b,group_g
    // if(/^(group_b|group_g|newterminals)$/.test(ams_actdesc.sServiceDepartment)){
    // 全量发布
    url = "".concat(location.protocol, "//").concat(amsActdesc.sAmeMobileUrl, "?ameVersion=0.3&sServiceType=").concat(data.sData.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=").concat(data.sData.sServiceDepartment); // }
  } // ----end
  // add susahuang 2016/11/22


  if (_typeof(amsActdesc.sSDID) !== undefined) {
    url += "&sSDID=".concat(amsActdesc.sSDID);
  } // 增加sMiloTag参数作为请求唯一标识


  var arrMiloTag = ['AMS', 'MILO']; // 活动号

  if (data.iActivityId) {
    arrMiloTag.push(data.iActivityId);
  } else {
    var _path = location.href.replace(/(\?|\#).*/, '');

    _path = _path.replace(/(\:|\/|\.|\-)/g, '_');
    arrMiloTag.push(_path);
  } // 流程号：


  if (data.iFlowId) {
    arrMiloTag.push(data.iFlowId);
  } else {
    arrMiloTag.push('OTHER');
  } // uin或openid


  if (miloCookie.get('acctype')) {
    arrMiloTag.push(miloCookie.get('openid') || miloCookie.get('uin') || 'unknown');
  } else {
    arrMiloTag.push(miloCookie.get('uin') || miloCookie.get('openid') || 'unknown');
  } // timestamp (ms)


  arrMiloTag.push(new Date().getTime()); // randomStr

  var sRandomMask = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var sRandomVal = '';

  for (var i = 0; i < 6; i++) {
    var rIndex = Math.floor(62 * Math.random());
    sRandomVal += sRandomMask.substr(rIndex, 1);
  }

  arrMiloTag.push(sRandomVal); // 放入url作为GET参数传过去

  url += "&sMiloTag=".concat(arrMiloTag.join('-'));
  url += "&_=".concat(new Date().getTime()); // 判断测试，预发布环境

  if ('test' == miloUrl.request('sAmsEnv')) {
    // test环境
    url = url.replace(/^https?\:\/\/([\w\-]+\.)+qq\.com/, "".concat(location.protocol, "//ame-test.odp.qq.com"));
  } else if ('pre' == miloUrl.request('sAmsEnv')) {
    // pre环境
    url = url.replace(/^https?\:\/\/([\w\-]+\.)+qq\.com/, "".concat(location.protocol, "//ame-pre.odp.qq.com"));
  }

  return url;
};

var postByCors = function postByCors(fl) {
  return new Promise(function (resolve, reject) {
    var amsActdesc = window["ams_actdesc_".concat(fl.flowJsonData.iActivityId)];
    var url = getRequestUrl(fl.flowJsonData, amsActdesc);

    var onSuccess = function onSuccess(data, xhr) {
      // self.timecost.end(self.flowJsonData.iFlowId);
      // add by dickma 2014.8.4: 返回503时，在flowengine里因为不是JSON，不能判断，所以在engine里直接字符串判断
      if (xhr.responseText.indexOf('An error occurred. 503') != -1) {
        miloCookie.set('_AMSSafeguard', new Date().getTime() + 30 * 1000, 30, window.location.host, '/', false);
        alert('很抱歉当前访问人数过多,请稍后再试'); // 关闭加载Loading
        // dialog.hideLoading();

        return;
      } // 增加HttpCode上报


      if (200 == xhr.status) {
        // 正常情况下
        var objData = JSON.parse(xhr.responseText);

        if (miloUrl.request('mconsole') == 1) {
          console.info("Response:".concat(xhr.responseText));
        }

        resolve(objData);
      } else {
        // 上报非200错误
        reject({
          url: url,
          statusCode: xhr.status
        }); // dialog.hideLoading();
        // ATM.reportATM({
        //     toappid: 1,
        //     tomoduletype: url.replace(/\?.+/,''),
        //     tointer: 1,
        //     toreturncode: 1,
        //     result: 0-xhr.status,
        //     serialnum: '',
        //     actid: ams_actdesc.iActivityId,
        //     businesstype: self.flowJsonData.sData.sServiceType,
        //     errormsg: '服务器'+xhr.status,
        //     timecost:self.timecost.getTimeCost(self.flowJsonData.iFlowId)
        // });
        // if(GLOBAL_STATUS_ERROR[xhr.status]){
        //     DD_GLOBAL_SATAUS_ERROR(GLOBAL_STATUS_ERROR[xhr.status]);
        // }else{
        //     DD_GLOBAL_SATAUS_ERROR(GLOBAL_STATUS_ERROR['other']);
        // }
      }
    }; // 发起ame请求


    request.post({
      url: url,
      xhrFields: {
        withCredentials: true
      },
      data: Object.serialize(fl.flowJsonData.sData),
      success: onSuccess,
      fail: function fail(xhr) {
        reject({
          url: url,
          statusCode: xhr.status
        });
      }
    }); // EAS 上报活动号/流程号

    if (isObject(window.EAS)) {
      window.EAS.SendAmsLog(fl.flowJsonData.iActivityId, fl.flowJsonData.iFlowId);
    } // 增加debug模式
    // debug == 1 开启使用milo加载未压缩版js方便调试
    // debug == 2 开启提交到ame的展示层(包括cookie)


    if (miloUrl.request('debug') == 2) {
      try {
        var postDataHtmlStr = ''; // eslint-disable-next-line no-restricted-syntax

        for (var i in fl.flowJsonData.sData) {
          postDataHtmlStr += "".concat(i, ":").concat(decodeURIComponent(fl.flowJsonData.sData[i]), ";&nbsp;&nbsp;");
        }

        g('amsTransmitPostDataInfo').innerHTML = postDataHtmlStr;
      } catch (e) {//
      }
    }
  });
};

export default postByCors;